import { FadeIn } from "./FadeIn";
import { Users, Maximize, Snowflake } from "lucide-react";
import { LUXURY_ROOM_URL } from "@/config/assets";

const VENUES = [
  {
    title: "Large Banquet",
    stat: "3,650",
    statUnit: "Sq. Ft.",
    capacity: "Perfect for 350 to 400 guests",
    icon: Users,
    testid: "venue-card-large-banquet",
  },
  {
    title: "Small Banquet",
    stat: "1,600",
    statUnit: "Sq. Ft.",
    capacity: "Perfect for 125 to 150 guests",
    icon: Maximize,
    testid: "venue-card-small-banquet",
  },
  {
    img: LUXURY_ROOM_URL,
    title: "Luxury Accommodations",
    stat: "6",
    statUnit: "Rooms · 1,500 Sq. Ft. each",
    capacity: "Fully Air-Conditioned expansive suites",
    icon: Snowflake,
    testid: "venue-card-luxury-rooms",
  },
];

export const Venues = () => (
  <section id="venues" data-testid="venues-section" className="grain-overlay bg-white py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <FadeIn>
        <p className="text-[#097969] uppercase tracking-[0.4em] text-xs mb-5">The Space Breakdowns</p>
        <h2 className="font-serif-luxe text-4xl md:text-5xl font-medium text-[#043927] max-w-2xl leading-tight">
          Venues & <span className="italic">Accommodations</span>
        </h2>
      </FadeIn>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
        {VENUES.map((v, i) => (
          <FadeIn key={v.title} delay={i * 0.15}>
            <div
              data-testid={v.testid}
              className="group h-full bg-[#FAF9F6] border border-[#D4AF37]/30 rounded-sm overflow-hidden transition-transform duration-500 hover:-translate-y-1.5 hover:shadow-[0_16px_40px_rgba(4,57,39,0.14)]"
            >
              {v.img ? (
                <div className="overflow-hidden h-64">
                  <img
                    src={v.img}
                    alt={v.title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                </div>
              ) : (
                <div className="h-64 bg-[#043927] relative flex flex-col items-center justify-center overflow-hidden">
                  <div className="absolute inset-0 opacity-[0.07]" style={{ backgroundImage: "radial-gradient(circle at 30% 40%, #D4AF37 1px, transparent 1px)", backgroundSize: "28px 28px" }} />
                  <span className="font-serif-luxe text-7xl font-medium text-[#D4AF37]">{v.stat}</span>
                  <span className="mt-2 text-xs uppercase tracking-[0.35em] text-[#F3E5AB]/80">{v.statUnit}</span>
                </div>
              )}
              <div className="p-8">
                <v.icon className="text-[#D4AF37] mb-4" size={26} strokeWidth={1.5} />
                <h3 className="font-serif-luxe text-2xl md:text-3xl text-[#043927] font-medium">{v.title}</h3>
                <p className="mt-3 text-[#097969] font-semibold tracking-wide">{v.stat} {v.statUnit}</p>
                <p className="mt-2 text-sm text-[#1A1A1A]/70 leading-relaxed">{v.capacity}</p>
              </div>
            </div>
          </FadeIn>
        ))}
      </div>
    </div>
  </section>
);
